import { fmtMoneyTable } from '../QuickCashflowModel/calc/formatters';

export function todayIsoDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** ISO YYYY-MM-DD (or legacy free-text) to US mm/dd/yyyy for term sheet clauses. */
export function formatTermSheetUsDate(value) {
  if (!value) {
    return '[]';
  }
  const text = String(value).trim();
  const isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[2]}/${isoMatch[3]}/${isoMatch[1]}`;
  }
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(text)) {
    return text;
  }
  return text || '[]';
}

/** PercentageNumberInput stores decimals (0.2 = 20%). */
export function pctDisplayNumber(value) {
  if (value === '' || value == null) {
    return null;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  const pct = n * 100;
  if (Number.isInteger(pct)) {
    return String(pct);
  }
  return String(Math.round(pct * 100) / 100);
}

export function fmtPctDisplay(value) {
  const pct = pctDisplayNumber(value);
  if (pct == null) {
    return null;
  }
  return `${pct}%`;
}

export function fmtUsdDisplay(value) {
  if (value === '' || value == null) {
    return null;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  return fmtMoneyTable(n);
}

export function fmtUsdDocx(value) {
  const formatted = fmtUsdDisplay(value);
  if (!formatted) {
    return '[]';
  }
  return formatted.replace(/^\$/, '');
}

/** Amount only (no leading $) for strings that already use a "US $" prefix. */
export function fmtUsdAmount(value) {
  const formatted = fmtUsdDisplay(value);
  if (!formatted) {
    return null;
  }
  return formatted.replace(/^\$/, '');
}

export function hasExpandedAmount(value) {
  if (value === '' || value == null) {
    return false;
  }
  const n = Number(value);
  return Number.isFinite(n) && n > 0;
}

export function buildExpandedAmountClause(value) {
  if (!hasExpandedAmount(value)) {
    return '. ';
  }
  return `, with an option to expand to US ${fmtUsdDisplay(value)} upon mutual consent. `;
}
